exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hey-delta[data-v-5e3eff56],\n.hey-delta-case[data-v-5e3eff56] {\n  width: 320px;\n  height: 50px;\n}\n@media (min-width: 480px) {\n.hey-delta[data-v-5e3eff56],\n  .hey-delta-case[data-v-5e3eff56] {\n    width: 468px;\n    height: 60px;\n}\n}\n", ""]);

// exports
